"use strict";

/**
 * Style-Typen.
 *
 * @enum {string}
 */
gc.gis.factory.StyleType = {
	/**
	 * Objekt existiert aber wird nicht angezeigt.
	 */
	TRANSPARENT:        'transparent',
	/**
	 * Objekt soll hervorgehoben werden.
	 */
	HIGHLIGHT:          'highlight',
	/**
	 * Objekt soll hervorgehoben werden und ist aktiv z.B. durch Hover.
	 */
	HIGHLIGHT_ACTIVE:   'highlight:active',
	/**
	 * Objekt aus Verortung werden.
	 */
	GEOCODE:            'geocode',
	/**
	 * Objekt aus Verortung werden und ist aktiv z.B. durch Hover.
	 */
	GEOCODE_ACTIVE:     'geocode:active',
	/**
	 * Objekt kann selektiert werden.
	 */
	SELECTABLE:         'selectable',
	/**
	 * Objekt ist selektiert.
	 */
	SELECTED:           'selected',
	/**
	 * Messung während des Zeichenvorgangs.
	 */
	MEASURE:            'measure',
	/**
	 * Messung abgeschlossen.
	 */
	MEASURE_FINAL:      'measure:final',
	/**
	 * Messung aktives Segment.
	 */
	MEASURE_ACTIVE:     'measure:active',
	/**
	 * Während des Zeichnens.
	 */
	DRAW:               'draw',
	/**
	 * Zeichenvorgang abgeschlossen.
	 */
	DRAW_FINAL:         'draw:final',
	/**
	 * Objekt wurde von WFS geladen.
	 */
	WFS:                'wfs'
};

/**
 * @classdesc
 * Implementierung einer Factory zur Bereitstellung von Styles.
 *
 * @class
 * @memberof gc.gis.factory
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.factory.StyleFactory = function()
{
	this._style = {};

	this._styleFunction = {};

	this._init();
};

/**
 * Erzeugt eine Style-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @param {string} type Name des Style-Typs
 * @return {T} Style gemäß verwendeter Kartenbibliothek
 */
gc.gis.factory.StyleFactory.prototype.getStyle = function (type)
{
	return this._style[type];
};

/**
 * Erzeugt eine StyleFunction-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @param {string} type Name des Style-Typs
 * @return {Function} Style-Funktion gemäß Kartenbibliothek
 */
gc.gis.factory.StyleFactory.prototype.getStyleFunction = function (type)
{
	var self = this;

	return this._styleFunction[type] || function (feature, resolution) {
		return self._style[type];
	};
};

/**
 * Erzeugt eine StyleFunction-Implementierung für ein einzelnes Feature in Abhängigkeit der Kartenbibliothek.
 *
 * @param {string} type Name des Style-Typs
 * @return {Function} Style-Funktion auf Featureebene gemäß Kartenbibliothek
 */
gc.gis.factory.StyleFactory.prototype.getFeatureStyleFunction = function (type)
{
	var self = this;

	return function (feature, resolution) {
		// innerhalb einer featureStyleFunction ist "this" das aktuelle Feature
		return self._styleFunction[type](feature, resolution) ||
			(function(feature, resolution) {
				return self._style[type];
			}(feature, resolution));
	};
};

/**
 * Initialisiert die Factory.
 *
 * @abstract
 * @protected
 */
gc.gis.factory.StyleFactory.prototype._init = gc.gis.abstractMethod;